/* c8 ignore start */
import { defineVueComponentAEM } from '@dh-io-owpi/shared/src/aem/vue';
import { registerComponentInRUM } from '@dh-io-owpi/shared/src/utils/ddRum';
import App from './App.vue';

registerComponentInRUM();

defineVueComponentAEM(App, import.meta.env.APP_NAME);
